/* eslint-disable */
import { IFilterCriteriaModel } from "@fr/vue/types/backboneModels/BackboneFiltersCriteriaModel";

const ARRAY_UNTRACEABLE_FILTERS: Array<keyof IFilterCriteriaModel> = ['typeDistanceLift', 'restType'];

export { ARRAY_UNTRACEABLE_FILTERS };